import React, { Fragment, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useForm } from "react-hook-form";
import {
  formBtn1,
  labelClass,
  inputClass,
  formBtn2,
} from "../Utils/CustomClasses";
import Error from "../Error/Error";
import { useDispatch, useSelector } from "react-redux";
import { EditProfileAPI } from "../../API/Api";
import { toast } from "react-toastify";
import { setUserDetails } from "../../Redux/Slice/LoginSlice";
import { validateEmail } from "../Utils/Validation";

export default function EditProfileModal({ editModal, setEditModal }) {
  const UserDetails = useSelector((state) => state?.login?.userDetails);
  const {
    register,
    handleSubmit,
    control,
    watch,
    reset,
    formState: { errors },
    setValue,
  } = useForm();
  const dispatch = useDispatch();
  const toggle = () => {
    setEditModal(false);
    reset();
  };

  const onSubmit = async (data) => {
    let response = await EditProfileAPI(UserDetails?._id, data);
    if (response.status == 201) {
      toggle();
      dispatch(setUserDetails(response?.data?.data));
      toast.success(response?.data?.message);
    } else {
      toast.error(response?.response?.data?.error);
    }
  };

  useEffect(() => {
    if (editModal) {
      reset({
        first_name: UserDetails?.first_name,
        last_name: UserDetails?.last_name,
        email: UserDetails?.email,
        phone_number: UserDetails?.phone_number,
      });
    }
  }, [editModal]);
  return (
    <>
      <Transition appear show={editModal} as={Fragment}>
        <Dialog as="div" className="relative z-[100]" onClose={toggle}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-scroll">
            <div className="flex items-center justify-center min-h-full p-2 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
                  <Dialog.Title
                    as="h2"
                    className="w-full px-3 py-4 text-lg font-semibold leading-6 text-white bg-base-color font-tb"
                  >
                    Edit Profile
                  </Dialog.Title>
                  <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="p-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <label className={labelClass}>
                              First name<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              className={inputClass}
                              {...register("first_name", { required: true })}
                            />
                            {errors.first_name && (
                              <Error title="First Name is Required*" />
                            )}
                          </div>
                          <div>
                            <label className={labelClass}>
                              Last name<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              className={inputClass}
                              {...register("last_name", { required: true })}
                            />
                            {errors.last_name && (
                              <Error title="Last Name is Required*" />
                            )}
                          </div>
                          <div>
                            <label className={labelClass}>
                              Email<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              className={inputClass}
                              {...register("email", {
                                validate: validateEmail,
                              })}
                            />
                            {errors.email && (
                              <Error title={errors.email.message} />
                            )}
                          </div>
                          <div>
                            <label className={labelClass}>
                              Phone no<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              className={inputClass}
                              {...register("phone_number", { required: true })}
                            />
                            {errors.phone_number && (
                              <Error title="Phone Number is Required*" />
                            )}
                          </div>
                        </div>
                      </div>
                      <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                        <button
                          type="submit"
                          className={`${formBtn1} px-4 py-2 text-white font-bold rounded-lg`}
                        >
                          Submit
                        </button>
                        <button
                          type="button"
                          className={`base-gray-light px-4 py-2 ${formBtn2} font-bold rounded-lg`}
                          onClick={toggle}
                        >
                          Close
                        </button>
                      </footer>
                    </form>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
